// import $ from "jquery";
import { createGuid } from "#scripts/general_functions";
import load from '@pandasekh/dynamic-script-loader';

export default (_content) => {
    let content = _content;
    const localSRUId = window.serverdata.configMeta.aim.sru || `sru.${window.serverdata.configMeta.aim.nameId}.kommune.no`;
    const localPostlisteId = window.serverdata.configMeta.aim.postliste || `postliste.${window.serverdata.configMeta.aim.nameId}.kommune.no`;
    const localInnsynRequestMail = window.serverdata.configMeta.aim.innsynRequestMail || `postmottak@${window.serverdata.configMeta.aim.nameId}.kommune.no`;

    // byggesak innsyn
    content = content.replace(
        /(\[modul:byggsakinnsyn\])/gim,
        `
            <script type="text/javascript"
                    src=" //dev.prokomcdn.no/richard/cdn-resources/plugins/byggsak-innsyn/browser-app/js/scripts.min.js"
                    id="frame-init"
                    data-resource="https://byggesakinnsyn2.kongsberg.kommune.no/?advancedSearch=true"
                    data-iframe="true"
                    data-css=""
                    data-skjema=""
                    data-scrolling=""
                    data-frameid="portalframe1"
                    allowtransparency="true">
            </script>
    `,
    );

    content = content.replace(
        /(\[modul:byggsakinnsyn_gammel\])/gim,
        `
            <script type="text/javascript"
                    src=" //dev.prokomcdn.no/richard/cdn-resources/plugins/byggsak-innsyn/browser-app/js/scripts.min.js"
                    id="frame-init"
                    data-resource="https://byggesakinnsyn.kongsberg.kommune.no/?advancedSearch=true"
                    data-iframe="true"
                    data-css=""
                    data-skjema=""
                    data-scrolling=""
                    data-frameid="portalframe1"
                    allowtransparency="true">
            </script>
    `,
    );

    // SRU

    content = content.replace(
        /(\[modul:sru\])/gim,
        `
            <script type="text/javascript"
                    src="//prokomresources.prokomcdn.no/plugins/sru-v2/browser-app/js/scripts.min.js"
                    id="frame-init"
                    data-resource="https://${localSRUId}"
                    data-iframe="true"
                    data-css=""
                    data-skjema=""
                    data-scrolling=""
                    data-frameid="portalframe1"
                    allowtransparency="true">
    `,
    );

    content = content.replace(
        /(\[modul:aim-sru\])/gim,
        `
                    <script type="module" crossorigin src="https://preview.prokomcdn.no/products/sru-frontend/dist/index.js"></script>
                    <div class="sru-container" datasource="${localSRUId}" ${window.serverdata.configMeta.aim.lang === "nn" ? 'lang="nn-NO"' : ""} style="min-height: 600px; margin: 50px 0;"></div>`,
    );
    // Postliste

    content = content.replace(
        /(\[modul:postliste\])/gim,
        `
           <iframe src="//prokomresources.prokomcdn.no/plugins/postliste-v2/iframe-app/app.html?url=https://${localPostlisteId}&skjema=mailto:${localInnsynRequestMail}" width="100%" scrolling="no" id="portalframe1" frameborder="0"></iframe>
            
            <script type="text/javascript" src="//prokomresources.prokomcdn.no/plugins/postliste-v2/browser-app/js/scripts.min.js?v=1.01"></script>
    `,
    );

    // Norkart Kartløsning.
    if (content.match(/(\[modul:norkart_kart\])/gim)) {
        const id = createGuid();

        // importer(["//kommunekart.com/scripts/kommunekart.min.js"]).then(() => {
        load('//kommunekart.com/scripts/kommunekart.min.js').then((element) => {
            // $(`#${id}`).html(
            document.getElementById(id).innerHTML = `<div id="kartcontainer" style="height:450px;">&nbsp;</div>
            <script>
                var kommunekart = new Kommunekart.Map({
                    "container":"kartcontainer",
                    "appId":"-Kongsberg-Publikumsklient-",
                    "municipality":"0604",
                    "municipalityControl":true,
                    "lockMunicipality":false,
                    "lockSearch":true,
                    "menu":true,
                    "search":true,
                    "navigation":true,
                    "locate":true,
                    "layerSelect":true,
                    "getFeatureInfo":true,
                    "measure":true,
                    "draw":true,
                    "poi":true,
                    "print":true,
                    "startupLocation":"funksjon:VisPunkt;x:59.66363386693962;y:9.643495691737712;zoom:14.011142398783178;markering:1",
                    "activatedLayers":null,
                    "viewer3D":true,
                    "fullscreenButton":true,
                    "legend":true,
                    "analysis":false,
                    "neighbourList":false,
                    "planSearch":false,
                    "customSearch":false,
                    "share":true,
                    "compassControl":true,
                    "tiltControl":true,
                    "detailInfo":true,
                    "detailInfoFirstSection":true
                });
            </script>`;
        });

        content = content.replace(/(\[modul:norkart_kart\])/gim, `<div class="modelpostload module__fullwidth" id="${id}"></div>`);
    }

    const match = content.match(/\[modul:norkart_renovation:(\d+)?\]/i);
    if (match) {
        let kommuneNr = 0;
        if (match.length >= 2) {
            kommuneNr = match[1];
        }

        content = content.replace(
            /\[modul:norkart_renovation:(\d+)\]/gim,
            `           
          <iframe src="/toemmekalender.html?kommunenr=${kommuneNr}" width="100%" scrolling="no" id="kartcontainer" frameborder="0" style="height: 880px;"></iframe>
      `,
        );
    }

    return content;
};
